import { InjectionToken } from '@angular/core';

export const CONFIGURATION = new InjectionToken('configuration');
